// Port of api/fuel/app/classes/filter/package/games/rating/package/revisions.php
import F from 'offline/filter/constants'
export default {
	run: function(pkg, local, global) {
		if (global.ownerType !== F.OWNER_USER) return pkg
		var revisions = (global.revisions && global.revisions[local.game_id]) ? global.revisions[local.game_id] : []
		pkg.revisions = { count: revisions.length, history: [], change: 0 }
		if (revisions.length) pkg.revisions.count = revisions.length - 1
		var last4 = revisions.slice(-4)
		for (var i = 0; i < last4.length; i++) {
			pkg.revisions.history.push({
				value: Math.round(parseFloat(last4[i].log_rating || 0) * 10) / 10,
				date: parseInt(last4[i].log_date || 0, 10),
				initial: parseInt(last4[i].log_initial_sync || 0, 10)
			})
		}
		if (revisions.length >= 2) {
			pkg.revisions.change = parseFloat(local.rating.log_rating || 0) - parseFloat(revisions[revisions.length - 2].log_rating || 0)
		}
		return pkg
	}
}
